import styles from './product-comparison-grid.module.scss';
export interface ProductComparisonGridProps {
  children: React.ReactNode;
  classname?: string;
}

const ProductComparisonGrid = ({
  children,
  classname
}: ProductComparisonGridProps) => {
  return (
    <div
      className={`${styles['product-comparison-grid']} ${classname}`}
      data-testid="product-comparison-grid"
    >
      {children}
    </div>
  );
};

export default ProductComparisonGrid;
